/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Date_DayInputs */

const en_us2_onboarding_date_day = /** @type {(inputs: Onboarding_Date_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DD`)
};

const pt_br2_onboarding_date_day = /** @type {(inputs: Onboarding_Date_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dd`)
};

const es_419_onboarding_date_day = /** @type {(inputs: Onboarding_Date_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dd`)
};

const pt_pt2_onboarding_date_day = /** @type {(inputs: Onboarding_Date_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dd`)
};

const fr_fr2_onboarding_date_day = /** @type {(inputs: Onboarding_Date_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JJ`)
};

const de_de2_onboarding_date_day = /** @type {(inputs: Onboarding_Date_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TT`)
};

const it_it2_onboarding_date_day = /** @type {(inputs: Onboarding_Date_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GG`)
};

/**
* | output |
* | --- |
* | "DD" |
*
* @param {Onboarding_Date_DayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_date_day = /** @type {((inputs?: Onboarding_Date_DayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Date_DayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_date_day(inputs)
	if (locale === "es-419") return es_419_onboarding_date_day(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_date_day(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_date_day(inputs)
	if (locale === "de-DE") return de_de2_onboarding_date_day(inputs)
	if (locale === "it-IT") return it_it2_onboarding_date_day(inputs)
	return en_us2_onboarding_date_day(inputs)
});
export { onboarding_date_day as "onboarding.date_day" }